import styled from 'styled-components';

export const Styles = styled.div`
  .course-grid-area {
    padding: 70px 0;

    @media (max-width: 767px) {
      padding: 40px 0 30px;
    }
  }
`;
